import { http } from '@api/http'
import { FullScreenLoader } from '@components/FullScreenLoader'
import { Initializer } from '@components/RouteComponents'
import {
  setAnalyticsOrgId,
  setAnalyticsOrgKey,
  setSuperProperties,
} from '@lib/analytics'
import {
  orgDetailsQueryOptions,
  whiteLabelDetailsQueryOptions,
} from '@src/queryOptions/org'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { rootSearchSchema } from './-searchSchemas/rootSearchSchema'

export const Route = createFileRoute('/')({
  validateSearch: zodValidator(rootSearchSchema),
  loaderDeps: ({ search }) => ({ search }),
  beforeLoad: ({ search: { bypassFlow, org }, context, location }) => {
    if (bypassFlow) {
      const storeActions = context.store.getActions().onboarding
      storeActions.setAppInitialized(true)
      org && storeActions.setOrgId(org)
      redirect({ to: '/accountCreated', search: location.search, throw: true })
    }
  },
  loader: async ({ deps: { search }, context: { queryClient, store } }) => {
    const { org } = search
    const storeActions = store.getActions().onboarding
    if (org) {
      const orgDetails = await queryClient.ensureQueryData(
        orgDetailsQueryOptions({ organizationId: org })
      )
      const appId = orgDetails.data.app_identifier
      setAnalyticsOrgId(org)
      setAnalyticsOrgKey(orgDetails.data.org_key)
      setSuperProperties({
        org_id: org,
      })
      if (appId) {
        http.defaults.headers.common['App-ID'] = appId
        await queryClient.fetchQuery(whiteLabelDetailsQueryOptions)
      }
    }

    const {
      accountToken,
      allowExit,
      failKycInquiry,
      bypassCard,
      callbackUrl,
      emailAddress,
      embedded,
      emp,
      firstName,
      instance,
      kycReferenceId,
      lastName,
      phoneNumber,
    } = search
    org && storeActions.setOrgId(org)
    embedded && storeActions.setEmbedded(embedded)
    allowExit && storeActions.setAllowExit(allowExit)
    instance && storeActions.setInstanceId(instance)
    emp && storeActions.setEmployeeId(emp)
    firstName && storeActions.setFirstName(firstName)
    lastName && storeActions.setLastName(lastName)
    phoneNumber && storeActions.setPhone(phoneNumber)
    emailAddress && storeActions.setEmail(emailAddress)
    callbackUrl && storeActions.setCallbackUrl(callbackUrl)
    accountToken && storeActions.setAccountToken(accountToken)
    kycReferenceId && storeActions.setKycReferenceId(kycReferenceId)
    bypassCard && storeActions.setBypassCard(bypassCard)
    failKycInquiry && storeActions.setFailKycInquiry(failKycInquiry)
    storeActions.setAppInitialized(true)
  },
  pendingComponent: FullScreenLoader,
  component: Initializer,
})
